import React from "react";
function PregnancyEducationalContent() {
  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <strong>Qu'est-ce qu'une calculatrice de grossesse et comment fonctionne-t-elle?</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Calculatrice de grossesse</strong> est un outil médical électronique qui aide les femmes enceintes à déterminer
                la date d'accouchement prévue et à calculer avec précision l'âge de la grossesse. La calculatrice est basée sur des formules
                médicales fiables telles que la <strong>Règle de Naegele</strong> utilisée par les médecins du monde entier.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Comment fonctionne une calculatrice de grossesse?
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                Une calculatrice de grossesse fonctionne à travers les étapes suivantes:
              </p>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Entrez la date de la dernière menstruation:</strong> C'est la date du début des dernières menstruations avant la grossesse.
                </li>
                <li>
                  <strong>Déterminez la durée du cycle:</strong> La moyenne normale est de 28 jours, mais elle varie d'une femme à l'autre (20-45 jours).
                </li>
                <li>
                  <strong>Calculez la date d'ovulation:</strong> Elle se produit généralement au milieu du cycle (environ jour 14 avant les prochaines menstruations).
                </li>
                <li>
                  <strong>Ajoutez 280 jours:</strong> C'est la durée normale d'une grossesse (40 semaines) à partir du premier jour des dernières menstruations.
                </li>
              </ol>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 Règle médicale de Naegele:</strong>
                <br />
                Pour calculer la date d'accouchement prévue:
                <br />
                • Soustrayez 3 mois de la date des dernières menstruations
                <br />
                • Ajoutez 7 jours
                <br />
                • Ajoutez un an
                <br/>                <strong>Exemple:</strong> Les dernières menstruations ont commencé le 10 janvier 2024
                <br />
                Calcul: 10 janvier - 3 mois + 7 jours = <strong>17 octobre 2024</strong>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Pourquoi calculons-nous à partir des dernières menstruations et non du jour de la conception?
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                La raison médicale est que la plupart des femmes se souviennent précisément du moment de leurs dernières menstruations,
                alors qu'il est difficile de déterminer le jour exact de la conception. C'est pourquoi les médecins ont convenu d'utiliser
                le premier jour des dernières menstruations comme point de départ unifié pour calculer la grossesse.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Stades de la grossesse en détail - Semaines et mois</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>La grossesse</strong> est divisée en trois stades principaux appelés trimestres,
                chaque stade ayant ses propres caractéristiques et développements:
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Premier trimestre de la grossesse (Semaines 1 - 13)
              </h3>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>Mois:</strong> Mois 1, 2, 3
                <br />
                Durant le premier trimestre, les changements se produisent rapidement.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PregnancyEducationalContent;